import { notify } from 'utils/reduxUtils';

export const types = {
  UPDATE_SUPPLIER_TAX_RATE_ERROR:
    'settings/accounting/UPDATE_SUPPLIER_TAX_RATE_ERROR',
  UPDATE_SUPPLIER_TAX_RATE_REQUEST:
    'settings/accounting/UPDATE_SUPPLIER_TAX_RATE_REQUEST',
  UPDATE_SUPPLIER_TAX_RATE_SUCCESS:
    'settings/accounting/UPDATE_SUPPLIER_TAX_RATE_SUCCESS',
};

export const updateSupplierTaxRate = {
  error: notify(
    (error) => ({
      type: types.UPDATE_SUPPLIER_TAX_RATE_ERROR,
      payload: error,
    }),
    "Can't update tax rate.",
  ),
  request: ({ taxRate, cb }) => ({
    type: types.UPDATE_SUPPLIER_TAX_RATE_REQUEST,
    payload: {
      taxRate,
      cb,
    },
  }),
  success: notify(
    () => ({
      type: types.UPDATE_SUPPLIER_TAX_RATE_SUCCESS,
    }),
    'New tax rate saved.',
  ),
};
